export const COLORS = ["#FFFFFF", "#000000", "#EF4444", "#F59E0B", "#22C55E", "#3B82F6", "#EC4899"];
export const FONT = "sans-serif";
export const FULL = { x: 0, y: 0, w: 1, h: 1 };
export const clamp = (v, min = 0, max = 1) => Math.min(max, Math.max(min, v));

export const loadImage = (src) =>
  new Promise((res, rej) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = rej;
    img.src = src;
  });

const blank = (w, h) => {
  const c = document.createElement("canvas");
  c.width = Math.round(w);
  c.height = Math.round(h);
  return c;
};

// Downscale huge camera shots so editing stays smooth on phones.
export function fitCanvas(img, max = 2560) {
  const s = Math.min(1, max / Math.max(img.width, img.height));
  const c = blank(img.width * s, img.height * s);
  c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
  return c;
}

export function rotateCanvas(src) {
  const c = blank(src.height, src.width);
  const ctx = c.getContext("2d");
  ctx.translate(c.width / 2, c.height / 2);
  ctx.rotate(Math.PI / 2);
  ctx.drawImage(src, -src.width / 2, -src.height / 2);
  return c;
}

export function cropCanvas(src, r) {
  const sx = r.x * src.width, sy = r.y * src.height;
  const c = blank(Math.max(1, r.w * src.width), Math.max(1, r.h * src.height));
  c.getContext("2d").drawImage(src, sx, sy, c.width, c.height, 0, 0, c.width, c.height);
  return c;
}

export function drawStroke(ctx, s) {
  ctx.strokeStyle = s.color;
  ctx.fillStyle = s.color;
  ctx.lineWidth = s.width;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
  if (s.points.length === 1) {
    const [x, y] = s.points[0];
    ctx.beginPath();
    ctx.arc(x, y, s.width / 2, 0, Math.PI * 2);
    ctx.fill();
    return;
  }
  ctx.beginPath();
  s.points.forEach(([x, y], i) => (i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)));
  ctx.stroke();
}

export function drawTexts(ctx, texts, w, h) {
  texts.forEach((t) => {
    const fs = t.size * w;
    const lines = t.text.split("\n");
    ctx.save();
    ctx.font = `700 ${fs}px ${FONT}`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = t.color;
    ctx.shadowColor = "rgba(0,0,0,0.6)";
    ctx.shadowBlur = fs * 0.12;
    lines.forEach((l, i) => ctx.fillText(l, t.x * w, t.y * h + (i - (lines.length - 1) / 2) * fs * 1.2));
    ctx.restore();
  });
}

export function flatten(base, strokes, texts) {
  const c = blank(base.width, base.height);
  const ctx = c.getContext("2d");
  ctx.drawImage(base, 0, 0);
  strokes.forEach((s) => drawStroke(ctx, s));
  drawTexts(ctx, texts, c.width, c.height);
  return c;
}

export const canvasToFile = (canvas) =>
  new Promise((res, rej) =>
    canvas.toBlob(
      (b) => (b ? res(new File([b], `photo-${Date.now()}.jpg`, { type: "image/jpeg" })) : rej(new Error("export failed"))),
      "image/jpeg",
      0.9,
    ),
  );
